import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AdjustmentProfileAction } from '../adjustmentProfile.action';

type IDependencies = IClientApiDependencySegment;

export const exportAdjustmentProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.api.exportAdjustmentProfiles().pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          AdjustmentProfileAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
